
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGIN_FAIL = 'LOGIN_FAIL'
const SET_AUTH_ERROR = 'SET_AUTH_ERROR'
const SET_AUTH_ERROR_MESSAGE = 'SET_AUTH_ERROR_MESSAGE'
const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN'
const SET_REFRESHING_TOKEN = 'SET_REFRESHING_TOKEN'
const RESET_SIGNUP_ERRORS = 'RESET_SIGNUP_ERRORS'

export const defaultAuthState = {
  token: null,
  expires: null,
  refresh_token: null,
  token_refreshing: null,
  error: false,
  errorMessage: null
}

export default (state = defaultAuthState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        error: false,
        id_token: action.payload.data.id_token,
        expires: action.payload.data.expires,
        lantekreportcount: action.payload.data.lantekreportcount || 1000,
        cometreportcount: action.payload.data.cometreportcount || 1000,
        configs: action.payload.data.configs || ""
      }
    case SET_AUTH_TOKEN:
      return {
        ...state,
        token: action.payload.access_token,
        refresh_token: action.payload.refresh_token,
        expires: action.payload.expires

      }
    case SET_REFRESHING_TOKEN:
      return {
        ...state,
        token_refreshing: action.token_refreshing
      }
    case LOGIN_FAIL:
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      }
    case SET_AUTH_ERROR:
      return {
        ...state,
        error: action.error
      }
    case SET_AUTH_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.message
      }
    case RESET_SIGNUP_ERRORS: {
      return {
        ...state,
        error: false
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/authReducer.js